







import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

/**
 * General Component for Fields of type PICTURE_UPLOAD
 *
 * https://confluence.ametras.com/x/2rdQAw
 */
@Component
export default class AmetrasPictureUploadFieldTemplate extends Vue {

    @Prop() textAlign!: 'LEFT' | 'RIGHT' | 'CENTER' | 'JUSTIFIED';
    @Prop() value!: string;
    @Prop() marginDefinition!: string;
    @Prop() paddingDefinition!: string;

}

